<template>
  <div class="bg_white pb48">
    <div class="mv">
      <img :src="require('@/assets/images/keepgoing/header.png')" alt="">
    </div>
    <div class="mt16"></div>
    <div class="stamp_image">
      <img :src="getStampImage()" alt="">
    </div>
    <div class="mt16"></div>
    <GeneralTitle :title="'つづけてプラス1 スタンプカード'" />
    <div class="container ml16 mr16 mt24">
      <ul class="section_list ab">
        <li class="">BC001で製品を10,000ポイント以上ご購入につきスタンプが押されます。</li>
        <li class="">スタンプが12個たまるとお好きな製品を1つプレゼントします。</li>
        <li class="">登録日より前に製品を購入した場合は、登録日以降にスタンプが押されます。</li>
      </ul>
    </div>
    <div class="mt16"></div>
    <div class="ml16 mr16">
      <BaseBtn :disabled="stampStatus != 'ACHIVED_UNSELECTED'" :btnText="'プレゼントを選ぶ'" :type="stampStatus != 'ACHIVED_UNSELECTED' ? 'disabled' : 'blue'"  @onClick="goPresent" class="mt24" />
      <BaseBtn v-if="stampStatus == 'ACHIVED_SELECTED' && selectedGiftProduct.giftProductId !== 0" :disabled="false" :btnText="'選択したプレゼントを確認'" :type="'blue'"  @onClick="goPresentComplete" class="mt24" />
    </div>
    <div class="mt16"></div>
    <router-link class="present_link ab" :to="{ name: 'KeepgoingProductList'}">プレゼントとして選択できる製品はコチラ</router-link>
    <div class="mt24"></div>
    <div class="container ml16 mr16">
      <PageTitle :title="'つづけてプラス1 サービス概要'" />
      <ul class="section_list mt16 rb">
        <li class="">すべてのナチュラリープラス会員の方が、「つづけてプラス1」の対象者です。</li>
        <li class="">BC001で製品を10,000ポイント以上12カ月間購入すると、13カ月目にお好きな製品を1つプレゼントします。（スーパー・リバイブ、IZUMIO48パックセット、N selection商品は対象外です）</li>
        <li class="">製品購入が12カ月継続するごとに、お好きな製品のプレゼントがずっと続きます。</li>
      </ul>
    </div>
    <div class="mt24"></div>
    <div class="container ml16 mr16">
      <PageTitle :title="'プレゼント製品選択のお手続きについて'" />
      <ul class="section_list mt16 rb">
        <li class="">12カ月目の製品を受け取った後に、プレゼント製品を選択いただくご案内が、メールまたは公式アプリCONPUSの通知で届きます。選択いただいた製品は、次回製品購入時に同梱してお送りいたします。</li>
        <li class="">プレゼント製品を選択する期限は半年間です。</li>
      </ul>
    </div>
    <div class="mt24"></div>
    <div class="container ml16 mr16">
      <PageTitle :title="'その他'" />
      <ul class="section_list mt16 rb">
        <li class="">定期購入（セット商品やお得定期便を含む）やその都度注文での購入も対象です。</li>
        <li class="">BC002以降での製品購入は対象外です。</li>
        <li class="">キャンペーン商品、サービス商品、各種ギフトセット、AND単品、N selection商品の購入は対象外です。</li>
        <li class="">製品を誤って受け取れず返品されても、再度購入していただければ「つづけてプラス1」の対象となります。</li>
      </ul>
    </div>
  </div>
</template>

<script>
import BaseTemplate from "@/views/common/BaseTemplate.vue";
import GeneralTitle from '@/components/common/GeneralTitle.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import BaseBtn from "@/components/common/BaseBtn.vue";
import { mapActions, mapGetters } from "vuex";
import Check from '@/model/getToken'

export default {
  components: {
    BaseTemplate,
    GeneralTitle,
    BaseBtn,
    PageTitle
  },
  data() {
    return {
      code: this.$route.query.code
    }
  },
  methods: {
    ...mapActions("keepgoing", ["updateStampCount"]),
    getStampImage() {
      let stampCount = this.stampCount;
      // stampCountを2けたに0埋めする
      let ret = ( '00' + stampCount ).slice( -2 );
      return require(`@/assets/images/keepgoing/stamp_${ret}.jpg`);
    },
    goPresent() {
      this.$router.push({ name: 'KeepgoingPresent' });
    },
    goPresentComplete() {
      this.$router.push({ name: 'KeepgoingPresentComplete' });
    }
  },
  computed: mapGetters('keepgoing', ['memberId', 'stampCount', 'stampStatus', 'selectedGiftProduct']),
  async mounted() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      try {
        await this.updateStampCount();
      } catch (error) {
        console.error('Failed to updateStampCount in component:', error);
      }
    }
  }
};
</script>


<style lang="css" scoped>
.section_list {
  font-size: 14px;
  line-height: 1.7;
  list-style: inside;
}
.present_link {
  color: #6E74FF;
  display: block;
  font-size: 16px;
  text-decoration: underline;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/keepgoing/Index.vue